module.exports = "/_next/static/images/WindEnergySolutions-0361d385a6a1999f6a060375a16ca4e6.webp";